export default "__VITE_ASSET__D66Ey992__"